import gsap from 'gsap'
import { callAfterResize, sel, selAll } from './utils'

import 'vidstack/player/styles/default/theme.css'
import 'vidstack/player/styles/default/layouts/video.css'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

export default function Zora() {
  // console.log('Zora')
  const heroPhoneW$ = sel('.zora-hero__phone-w')
  const heroTl = gsap.timeline()
  heroTl.from(heroPhoneW$, { yPercent: 10, opacity: 0, duration: 3, ease: 'power4.out', delay: 1 })

  const playerW$ = sel('.about-zora__vid-w:not(.hide)')
  const sec$ = sel('.about-zora-sec')
  const close$ = sec$.querySelector('.mod__x-w')
  const modW$ = sec$.querySelector('.mod-w')
  const mod$ = sec$.querySelector('.mod')
  const bg$ = sec$.querySelector('.mod-bg')
  // gsap.set(modW$, { autoAlpha: 0, display: 'none' })
  // const player$ = sel('#plyr')
  // const tl = gsap
  //   .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
  //   // , onStart: () => (modW$.style.display = 'block')
  //   .fromTo(modW$, { autoAlpha: 0, display: 'none' }, { autoAlpha: 1, display: 'block' })
  //   .from(modW$, { y: 50 }, 0)
  //
  // playerW$.onclick = () => {
  //   // console.log(player)
  //   tl.play()
  //   player.on('statechange', (event) => {
  //     // const instance = event.detail.plyr
  //   })
  //   setTimeout(() => {
  //     player.play()
  //   }, 2000)
  // }
  // ;[close$, bg$].forEach((el) => {
  //   el.onclick = () => {
  //     player.pause()
  //     tl.reverse()
  //   }
  // })
  // player.play()

  // Peter video on Social LP
  async function videoModal() {
    const videoBtn$ = sel('.about-zora__vid-w')
    if (!videoBtn$) return
    // const sec$ = sel('.peter-quote-sec')
    const close$ = sec$.querySelector('.mod__x-w')
    const modW$ = sec$.querySelector('.mod-w')
    const mod$ = sec$.querySelector('.mod')
    const bg$ = sec$.querySelector('.mod-bg')
    modW$.classList.add('display-hide')

    const _player = sec$.querySelector('.custom_player')
    console.log('videoBtn$', close$, modW$, mod$, bg$, _player)
    const player = await VidstackPlayer.create({
      target: _player,
      // src: 'youtube/4UgnVc7kRxE',
      // src: 'vimeo/1061484821',
      poster: 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/67ec2aaf454cc0ab8e781425_hero_q85.webp',
      crossOrigin: true,
      playsInline: true,
      viewType: 'video',
      load: 'idle',
      layout: new VidstackPlayerLayout(),
    })

    const tl = gsap
      .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
      .to(
        {},
        {
          onStart: () => {
            console.log('onStart')
            modW$.classList.remove('display-hide')
          },
          onReverseComplete: () => {
            modW$.classList.add('display-hide')
          },
          duration: 0.1,
        }
      )
      .to(modW$, { opacity: 1 })
      .from(mod$, { y: 50 }, 0)

    const closeModal = (e) => {
      e?.stopImmediatePropagation()
      tl.reverse()
      player.pause()
    }

    videoBtn$.onclick = (e) => {
      // console.log('pl', player.state.canPlay)
      tl.play()

      if (player.state.canPlay) {
        player.play()
      } else {
        player.addEventListener(
          'can-play',
          (event) => {
            // console.log('canplay')
            player.play()
          },
          { once: true }
        )
      }
    }
    ;[close$, bg$].forEach((el) => {
      el.onclick = closeModal
    })

    player.addEventListener('ended', (event) => {
      closeModal()
    })
    callAfterResize(() => closeModal())
  }
  videoModal()
}
